import React from 'react'
import ActivityIndicator from './forms/ActivityIndicator'
import PropTypes from 'prop-types'
import ShoppingCartIcon from 'images/shopping-cart.png'

const ShoppingCartButton = (props) => {
  const { onClick, color, disabled, count, icon, loading } = props

  const iconMap = {
    'shopping-cart': <img className={'shopping-cart-icon'} src={ShoppingCartIcon} alt="" />
  }
  return (
    <button
      onClick={onClick}
      className={`button button--is-${color} button--is-motor-shopping-cart-button`}
      disabled={disabled}>
      <div style={{ marginBottom: 0, marginHorizontal: 5, fontWight: 'bold', fontSize: 18 }}>
        {icon && iconMap[icon]}
      </div>
      {
        loading ?
          <div style={{ marginLeft: 10 }} >
            <ActivityIndicator color="#fff" />
          </div>
          :
          <div className='cart-count-wrapper'>
            <p style={{margin: 0, fontWeight: 'bold', fontSize: 15, textAlign: 'center', marginTop: 4 }}>
              {count}
            </p>
          </div>
      }
    </button>
  )
}

ShoppingCartButton.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.string
}

export default ShoppingCartButton